import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { DefaultValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useDictionaryCreate } from '@/module/Author/Dictionary/model/DictionaryQuery';
import {
  DictionarySchema,
  defaultDictionaryValues,
  dictionarySchema,
} from '@/module/Author/Dictionary/model/DictionarySchema';

import { useAppNotification } from '@feature/utils';

import { DictionaryForm } from './DictionaryForm';

export function DictionaryCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDictionaryCreate();

  const defaultValues: DefaultValues<DictionarySchema> = useMemo(
    () => ({
      ...defaultDictionaryValues,
    }),
    [],
  );

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: DictionarySchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newDictionary => {
        notification.success();
        navigate({ to: '/author/dictionary/$dictionaryId', params: { dictionaryId: String(newDictionary.id) } });
      },
    });
  };

  return (
    <DictionaryForm
      title={t('dictionaries.form.title.create')}
      schema={dictionarySchema}
      defaultValues={defaultValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
